<!-- Links to pages in KMD Booking, on the tenant's KMD domain (GET /kmdsettings); none until it is known,
     and none when the tenant has turned them off (kmd_setting.MenuLinksEnabled).
     Each carries the selected association's KMD customer id. -->
<ng-template #kmdPageLinks let-pages>
  @if (showKmdMenuLinks()) {
    @for (page of pages; track page.path) {
      <li class="menu-item nav-item">
        <a class="menu-link nav-link" [href]="kmdDomain() + page.path + kmdCustomerQuery()">
          <span class="menu-item-title">{{ page.title }}</span>
        </a>
      </li>
    }
  }
</ng-template>

<ng-template
  #associationMenuItems
  let-mainMenuItemName="mainMenuItemName"
  let-mainMenuItemExpanded="mainMenuItemExpanded"
  let-isOwnAssociation="isOwnAssociation"
>
  <!-- Min forening: the login's own association. Foreninger: the one last opened from the drawer
       (0 shows "Vælg en forening" with the drawer open). -->
  @let associationId =
    (isOwnAssociation ? associationsStore.selectedEntityId() : associationsStore.viewedAssociationId()) ?? 0;
  <li
    class="menu-item expandable-item nav-item"
    [routerLinkActive]="['active']"
    #hasActiveRouterLink="routerLinkActive"
  >
    <mat-expansion-panel
      [expanded]="hasActiveRouterLink.isActive || (!isOwnAssociation && isBookingPeriodActive())"
      [class.has-active-child]="hasActiveRouterLink.isActive || (!isOwnAssociation && isBookingPeriodActive())"
    >
      <mat-expansion-panel-header class="menu-link">
        <div class="item-header-content">
          <mat-panel-title>
            <mat-icon class="menu-item-icon">holiday_village</mat-icon>
            <span class="menu-item-title">{{ mainMenuItemName }}</span>
          </mat-panel-title>
        </div>
      </mat-expansion-panel-header>
      <ul class="menu-sub-navigation nav flex-column">
        <!-- Min forening has its bookings under Bookinger → Overblik instead. -->
        @if (!isOwnAssociation) {
          <li class="menu-item nav-item" [class.active]="bookingerLinkActive.isActive || isBookingPeriodActive()">
            <a
              class="menu-link nav-link"
              routerLinkActive
              #bookingerLinkActive="routerLinkActive"
              [class.active]="bookingerLinkActive.isActive || isBookingPeriodActive()"
              [routerLink]="['/associations', associationId, 'bookings']"
            >
              <span class="menu-item-title">Bookinger</span>
            </a>
          </li>
        }

        @if (canSeeAssociationUsers()) {
          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a
              class="menu-link nav-link"
              [routerLink]="['/associations', associationId, 'users']"
              [routerLinkActive]="['active']"
            >
              <span class="menu-item-title">Brugere</span>
            </a>
          </li>
        }

        <!-- The organisation's own pages in KMD Booking, on the tenant's KMD domain (GET /kmdsettings). -->
        @if (isOwnAssociation) {
          <ng-container [ngTemplateOutlet]="kmdPageLinks" [ngTemplateOutletContext]="{ $implicit: kmdAssociationPages() }" />
        }

        <!-- Last on purpose: the item below the KMD links in Min forening. In Min forening it needs
             view_association_website_text (showOwnWebsiteText), which a foreningsbooker lacks; a company's or
             internal customer's people have it too (2026-10-26). -->
        @if (!isOwnAssociation || showOwnWebsiteText()) {
          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a
              class="menu-link nav-link"
              [routerLink]="['/associations', associationId, 'edit']"
              [routerLinkActive]="['active']"
            >
              <span class="menu-item-title">Website tekst</span>
            </a>
          </li>
        }
      </ul>
    </mat-expansion-panel>
  </li>
</ng-template>

<div class="side-menu-branding">
  <svg width="118" height="30" viewBox="0 0 118 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M86.3247 26.1478C81.6979 26.1478 78.5262 22.3792 78.3945 18.4176C78.397 18.319 78.4096 18.2188 78.4096 18.1211C78.4096 18.0355 78.3979 17.9527 78.3965 17.8676C78.5476 13.9578 81.6761 10.2148 86.3247 10.2148C91.0886 10.2148 94.2656 14.1484 94.2656 18.1211C94.2656 22.3778 90.8864 26.1478 86.3247 26.1478ZM66.2315 26.1478C61.6056 26.1478 58.4335 22.3792 58.3018 18.4176C58.3047 18.319 58.3168 18.2188 58.3168 18.1211C58.3168 18.0355 58.3056 17.9527 58.3037 17.8676C58.4548 13.9578 61.5833 10.2148 66.2315 10.2148C70.8704 10.2148 73.996 13.9447 74.1573 17.8086C74.1559 17.886 74.1447 17.9624 74.1447 18.0403C74.1447 18.1458 74.1578 18.2527 74.1612 18.3581C74.0378 22.5161 70.7076 26.1478 66.2315 26.1478ZM46.1386 26.1478C41.4131 26.1478 38.1962 22.2162 38.1962 18.1622C38.1962 14.1483 41.3733 10.2148 46.1386 10.2148C50.7775 10.2148 53.9026 13.9447 54.0644 17.8085C54.0625 17.8859 54.0523 17.9624 54.0523 18.0403C54.0523 18.1457 54.0649 18.2526 54.0683 18.3581C53.9444 22.5161 50.6147 26.1478 46.1386 26.1478ZM108.141 18.121L116.327 7.53955H111.318L105.495 15.2397C105.153 15.7012 104.611 15.9736 104.034 15.9736H101.924L101.939 0H97.7023V13.9592C95.9774 9.55832 91.6053 6.36399 86.3243 6.36399C82.0285 6.36399 78.4291 8.45677 76.2814 11.4832C74.107 8.41033 70.459 6.36399 66.2313 6.36399C61.9359 6.36399 58.3365 8.45677 56.1888 11.4832C54.0149 8.41033 50.3665 6.36399 46.1387 6.36399C43.0117 6.36399 40.2545 7.47521 38.155 9.24532V0H33.9598V17.5381C33.9515 17.7055 33.9598 17.8719 33.9598 18.0402C33.9598 23.7163 38.5628 30 46.1387 30C50.7028 30 54.1418 27.7171 56.184 24.7187C58.2393 27.7427 61.6973 30 66.2313 30C70.7959 30 74.2344 27.7171 76.2766 24.7187C78.3319 27.7427 81.7899 30 86.3243 30C92.102 30 96.0912 26.3509 97.7023 22.2079V30H101.939V20.3343H103.946C104.5 20.3343 105.023 20.5897 105.362 21.0261L112.336 30H117.631L108.141 18.121ZM12.1794 26.1478C7.45345 26.1478 4.23656 22.2162 4.23656 18.1622C4.23656 14.1483 7.4136 10.2148 12.1794 10.2148C16.9433 10.2148 20.1203 14.1483 20.1203 18.1211C20.1203 22.3777 16.7411 26.1478 12.1794 26.1478ZM12.1794 6.36426C5.17357 6.36426 0 11.9184 0 18.0405C0 23.7166 4.60299 30.0003 12.1794 30.0003C15.4502 30.0003 18.1432 28.8252 20.1621 27.059V30.0003H24.3573V18.1823H24.3539C24.3544 18.1619 24.3573 18.1411 24.3573 18.1213C24.3573 11.7157 19.0209 6.36426 12.1794 6.36426Z"
      fill="#335072"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26.7275 20.6703H31.0786V16.3164H26.7275V20.6703Z"
      fill="#335072"
    />
  </svg>
</div>

<ul class="side-menu-navigation side-menu-main nav flex-column">
  <!-- Startside: KMD Booking's front page ({domain}/information), with the selected
       organisation's KMD customer id. An organisation's people — an association's, a company's or an
       internal customer's — with kmd_setting.MenuLinksEnabled. -->
  @if (currentUserLoggedIn && showOwnKmdLinks()) {
    <li class="menu-item nav-item">
      <a class="menu-link nav-link w-100" [href]="kmdDomain() + '/information' + kmdCustomerQuery()">
        <mat-icon class="menu-item-icon">home</mat-icon> <span class="menu-item-title">Startside</span>
      </a>
    </li>
  }

  <!-- Where everyone lands after signing in (landingRouteFor). An administrator gets the task list,
       whatever their permissions: the page leaves out the widgets they may not see rather than
       shutting them out. An association login gets the selected association's bookings. Held back
       until the user is known, so neither entry flashes into the other's menu. -->
  @if (currentUserLoggedIn) {
    <li
      class="menu-item expandable-item nav-item"
      [routerLinkActive]="['active']"
      #hasActiveRouterLink="routerLinkActive"
    >
      <mat-expansion-panel
        [expanded]="hasActiveRouterLink.isActive || (isAssociationLogin() && isBookingPeriodActive())"
        [class.has-active-child]="hasActiveRouterLink.isActive || (isAssociationLogin() && isBookingPeriodActive())"
      >
        <mat-expansion-panel-header class="menu-link">
          <div class="item-header-content">
            <mat-panel-title>
              <mat-icon class="menu-item-icon">dashboard</mat-icon>
              <span class="menu-item-title">{{ isAssociationLogin() ? 'Bookinger' : 'Dashboard' }}</span>
            </mat-panel-title>
          </div>
        </mat-expansion-panel-header>
        <ul class="menu-sub-navigation nav flex-column">
          @if (isAssociationLogin()) {
            <li class="menu-item nav-item" [class.active]="myBookingsLinkActive.isActive || isBookingPeriodActive()">
              <a
                class="menu-link nav-link"
                routerLinkActive
                #myBookingsLinkActive="routerLinkActive"
                [class.active]="myBookingsLinkActive.isActive || isBookingPeriodActive()"
                [routerLink]="['/associations/' + $safeNavigationMigration(associationsStore.selectedEntity()?.id) + '/bookings']"
              >
                <span class="menu-item-title">Overblik</span>
              </a>
            </li>
          } @else {
            <li class="menu-item nav-item" [routerLinkActive]="['active']">
              <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/dashboard/my-tasks']">
                <span class="menu-item-title">Mine opgaver</span>
              </a>
            </li>
          }
        </ul>
      </mat-expansion-panel>
    </li>
  }

  @if (canManageBookings) {
    <li
      class="menu-item expandable-item nav-item"
      [routerLinkActive]="['active']"
      #hasActiveRouterLink="routerLinkActive"
    >
      <mat-expansion-panel
        [expanded]="hasActiveRouterLink.isActive"
        [class.has-active-child]="hasActiveRouterLink.isActive"
      >
        <mat-expansion-panel-header class="menu-link">
          <div class="item-header-content">
            <mat-panel-title>
              <mat-icon class="menu-item-icon">event</mat-icon>
              <span class="menu-item-title">Booking</span>
            </mat-panel-title>
          </div>
        </mat-expansion-panel-header>
        <ul class="menu-sub-navigation nav flex-column">
          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/booking/calendar']">
              <span class="menu-item-title">Kalender</span>
            </a>
          </li>
          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/booking/list']">
              <span class="menu-item-title">Listevisning</span>
            </a>
          </li>
          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a
              class="menu-link nav-link"
              [routerLinkActive]="['active']"
              [routerLink]="['/booking/locker-rooms-calendar']"
            >
              <span class="menu-item-title">Omklædningsrum</span>
            </a>
          </li>
          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/booking/requests']">
              <span class="menu-item-title">Forespørgsler</span>
            </a>
          </li>
          @if (canManageCodes && hasDoorsModule()) {
            <li class="menu-item nav-item" [routerLinkActive]="['active']">
              <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/codes/logs']">
                <span class="menu-item-title">Dørkoder</span>
              </a>
            </li>
          }
          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/users/payments']">
              <span class="menu-item-title">Udestående</span>
            </a>
          </li>
          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/booking/balance']">
              <span class="menu-item-title">Balance</span>
            </a>
          </li>
        </ul>
      </mat-expansion-panel>
    </li>
  }

  @if (canManageUsers) {
    <li
      class="menu-item expandable-item nav-item"
      [routerLinkActive]="['active']"
      #hasActiveRouterLink="routerLinkActive"
    >
      <mat-expansion-panel
        [expanded]="hasActiveRouterLink.isActive"
        [class.has-active-child]="hasActiveRouterLink.isActive"
      >
        <mat-expansion-panel-header class="menu-link">
          <div class="item-header-content">
            <mat-panel-title>
              <mat-icon class="menu-item-icon">group</mat-icon>
              <span class="menu-item-title">Brugere</span>
            </mat-panel-title>
          </div>
        </mat-expansion-panel-header>
        <ul class="menu-sub-navigation nav flex-column">
          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/users/list']">
              <span class="menu-item-title">Find bruger</span>
            </a>
          </li>
        </ul>
      </mat-expansion-panel>
    </li>
  }
  @if (canManageFacilities) {
    <li
      class="menu-item expandable-item nav-item"
      [routerLinkActive]="['active']"
      #hasActiveRouterLink="routerLinkActive"
    >
      <mat-expansion-panel
        [expanded]="hasActiveRouterLink.isActive"
        [class.has-active-child]="hasActiveRouterLink.isActive"
      >
        <mat-expansion-panel-header class="menu-link">
          <div class="item-header-content">
            <mat-panel-title>
              <mat-icon class="menu-item-icon">home</mat-icon>
              <span class="menu-item-title">Anlæg</span>
            </mat-panel-title>
          </div>
        </mat-expansion-panel-header>
        <ul class="menu-sub-navigation nav flex-column">
          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/resources/list']">
              <span class="menu-item-title">Faciliteter</span>
            </a>
          </li>

          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a
              class="menu-link nav-link"
              [routerLinkActive]="['active']"
              [routerLink]="['/resources/manage-locker-rooms']"
            >
              <span class="menu-item-title">Omklædningsrum</span>
            </a>
          </li>

          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/opening-hours']">
              <span class="menu-item-title">Åbningstider</span>
            </a>
          </li>

          @if (canManagePrices) {
            <li class="menu-item nav-item" [routerLinkActive]="['active']">
              <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/schedules/list']">
                <span class="menu-item-title">Prisperioder</span>
              </a>
            </li>
          }
        </ul>
      </mat-expansion-panel>
    </li>
  }

  @if (canManageOthersAssociations) {
    <ng-container
      [ngTemplateOutlet]="associationMenuItems"
      [ngTemplateOutletContext]="{ mainMenuItemName: 'Foreninger', mainMenuItemExpanded: false, isOwnAssociation: false }"
    ></ng-container>
  }

  @if (isAssociationLogin()) {
    <li
      class="menu-item expandable-item nav-item"
      [routerLinkActive]="['active']"
      #hasActiveRouterLink="routerLinkActive"
    >
      <mat-expansion-panel
        [expanded]="hasActiveRouterLink.isActive"
        [class.has-active-child]="hasActiveRouterLink.isActive"
      >
        <mat-expansion-panel-header class="menu-link">
          <div class="item-header-content">
            <mat-panel-title>
              <mat-icon class="menu-item-icon">calendar_month</mat-icon>
              <span class="menu-item-title">Søg/Book</span>
            </mat-panel-title>
          </div>
        </mat-expansion-panel-header>
        <ul class="menu-sub-navigation nav flex-column">
          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/associations/search/union']">
              <span class="menu-item-title">Booking</span>
            </a>
          </li>
          <!-- Kamp is an association booking; a company's or internal customer's people book Booking and
               Arrangement (#797). -->
          @if (!ownIsOrganisation()) {
            <li class="menu-item nav-item" [routerLinkActive]="['active']">
              <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/associations/search/match']">
                <span class="menu-item-title">Kamp</span>
              </a>
            </li>
          }
          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a
              class="menu-link nav-link"
              [routerLinkActive]="['active']"
              [routerLink]="['/associations/event-request']"
            >
              <span class="menu-item-title">Arrangement</span>
            </a>
          </li>
        </ul>
      </mat-expansion-panel>
    </li>

    <!-- The organisation's own pages and its KMD pages. Each item needs a permission, so a role without any
         of them gets no panel (showOwnPanel). -->
    @if (showOwnPanel()) {
      <ng-container
        [ngTemplateOutlet]="associationMenuItems"
        [ngTemplateOutletContext]="{ mainMenuItemName: ownMenuName(), mainMenuItemExpanded: true, isOwnAssociation: true }"
      ></ng-container>
    }

    <!-- Tilskud, Dokumenter and Min konto (KMD_GROUPS): the organisation's grant pages and the login's account in KMD Booking, on the tenant's KMD domain
         (GET /kmdsettings). Left out entirely when the tenant has turned them off (kmd_setting.MenuLinksEnabled). A company's or internal
         customer's people get no Dokumenter group and no Foreningsansøgninger (the pages' types, #797).
         A page behind a KMD page permission the role lacks is left out, and so is a group left empty (kmdGroups). -->
    @if (showOwnKmdLinks()) {
      @for (group of kmdGroups(); track group.title) {
        <li class="menu-item expandable-item nav-item">
          <mat-expansion-panel [expanded]="false">
            <mat-expansion-panel-header class="menu-link">
              <div class="item-header-content">
                <mat-panel-title>
                  <mat-icon class="menu-item-icon">{{ group.icon }}</mat-icon>
                  <span class="menu-item-title">{{ group.title }}</span>
                </mat-panel-title>
              </div>
            </mat-expansion-panel-header>
            <ul class="menu-sub-navigation nav flex-column">
              <ng-container [ngTemplateOutlet]="kmdPageLinks" [ngTemplateOutletContext]="{ $implicit: group.pages }" />
            </ul>
          </mat-expansion-panel>
        </li>
      }
    }
  }

  @if (canManageSubscriptions) {
    <li
      class="menu-item expandable-item nav-item"
      [routerLinkActive]="['active']"
      #hasActiveRouterLink="routerLinkActive"
    >
      <mat-expansion-panel
        [expanded]="hasActiveRouterLink.isActive"
        [class.has-active-child]="hasActiveRouterLink.isActive"
      >
        <mat-expansion-panel-header class="menu-link">
          <div class="item-header-content">
            <mat-panel-title>
              <mat-icon class="menu-item-icon">credit_card</mat-icon>
              <span class="menu-item-title">Abonnementer</span>
            </mat-panel-title>
          </div>
        </mat-expansion-panel-header>
        <ul class="menu-sub-navigation nav flex-column">
          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/subscriptions/list']">
              <span class="menu-item-title">Opsætning</span>
            </a>
          </li>
          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/subscriptions/memberships']">
              <span class="menu-item-title">Medlemsskaber</span>
            </a>
          </li>
          <!-- <li class="menu-item nav-item" [routerLinkActive]="['active']">
          <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/subscriptions/groups']">
            <span class="menu-item-title">Grupper</span>
          </a>
        </li> -->
        </ul>
      </mat-expansion-panel>
    </li>
  }

  <!-- KMD → Foreningsportal: who gets it is decided in showKmdPortalLink. Links to the bare KMD domain. -->
  @if (showKmdPortalLink()) {
    <li class="menu-item expandable-item nav-item">
      <mat-expansion-panel [expanded]="false">
        <mat-expansion-panel-header class="menu-link">
          <div class="item-header-content">
            <mat-panel-title>
              <mat-icon class="menu-item-icon">apartment</mat-icon>
              <span class="menu-item-title">KMD</span>
            </mat-panel-title>
          </div>
        </mat-expansion-panel-header>
        <ul class="menu-sub-navigation nav flex-column">
          <li class="menu-item nav-item">
            <a class="menu-link nav-link" [href]="kmdDomain()">
              <span class="menu-item-title">Foreningsportal</span>
            </a>
          </li>
        </ul>
      </mat-expansion-panel>
    </li>
  }
</ul>

<ul
  class="side-menu-navigation side-menu-footer nav flex-column bg-white pt-0"
  [ngClass]="{ 'border-top': !isAssociationLogin() }"
>
  @if (canManageSettings) {
    <li
      class="menu-item expandable-item nav-item"
      [routerLinkActive]="['active']"
      #hasActiveRouterLink="routerLinkActive"
    >
      <mat-expansion-panel
        [expanded]="hasActiveRouterLink.isActive"
        [class.has-active-child]="hasActiveRouterLink.isActive"
      >
        <mat-expansion-panel-header class="menu-link">
          <div class="item-header-content">
            <mat-panel-title>
              <mat-icon class="menu-item-icon">settings</mat-icon>
              <span class="menu-item-title">Indstillinger</span>
            </mat-panel-title>
          </div>
        </mat-expansion-panel-header>
        <ul class="menu-sub-navigation nav flex-column">
          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/cms']">
              <span class="menu-item-title">CMS</span>
            </a>
          </li>
          @if (canManagePermissions) {
            <li class="menu-item nav-item" [routerLinkActive]="['active']">
              <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/roles/permissions']">
                <span class="menu-item-title">Rettigheder</span>
              </a>
            </li>
          }
          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/template']">
              <span class="menu-item-title">Skabeloner</span>
            </a>
          </li>
          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/tags']">
              <span class="menu-item-title">Tags</span>
            </a>
          </li>
          @if (canManageImport) {
            <li class="menu-item nav-item" [routerLinkActive]="['active']">
              <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/booking/import']">
                <span class="menu-item-title">Import</span>
              </a>
            </li>
          }
          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/settings/mail']">
              <span class="menu-item-title">Mail</span>
            </a>
          </li>
          @if (isSuperAdmin && canManageCodes) {
            <li class="menu-item nav-item" [routerLinkActive]="['active']">
              <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/codes/lock-installations']">
                <span class="menu-item-title">Låsesystemer</span>
              </a>
            </li>
          }
          @if (canManageModules()) {
            <li class="menu-item nav-item" [routerLinkActive]="['active']">
              <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/settings/modules']">
                <span class="menu-item-title">Moduler</span>
              </a>
            </li>
          }
        </ul>
      </mat-expansion-panel>
    </li>
  }

  <li class="menu-item nav-item" [routerLinkActive]="['active']">
    <a class="menu-link nav-link w-100" [routerLink]="['/help']">
      <mat-icon class="menu-item-icon">help</mat-icon> <span class="menu-item-title">Hjælp</span>
      @if (!isAssociationLogin() && helpStore.hasUnseenNews()) {
        <span class="menu-item-badge" title="Der er kommet en ny release siden sidst">Ny</span>
      }
    </a>
  </li>
</ul>
